<template>
  <ShowControl  @revert="revertClick"  :title="title" ref="showControl">
    <div style="margin-top: 3%; height: 90%; display: flex; display: -webkit-flex; width: 90%;">
      <div class="item"
          id="init">
          <div class="items"
              id="main5"
              v-if="true"></div>
        <div class="items"
            id="main6"
            v-if="true"></div>
      </div>
      <div class="item">
        <label>我们的问卷调查旨在了解参与者对会展的看法和体验。总体而言，调查结果显示参与者对会展持有积极态度，并且他们认为会展对于交流、展示和业务发展非常重要。
          调查发现，大多数参与者对会展的组织和安排表示满意。他们认为会展提供了一个良好的机会，可以与来自不同行业和背景的人交流，并且展示自己的产品和服务。此外，参与者对会展的规模和布局也给予了较高评价。
          此外，调查结果还显示，参与者对会展的参展商和展品质量有较高的期望。他们希望看到多样化的展品和创新的产品。对于参展商而言，他们希望能够得到更多的机会与潜在客户进行面对面的交流，并建立长期的合作关系。
          在改进方面，一些参与者提出了对会展的设施和服务方面的建议。他们希望有更多的休息区域和舒适的座位，以便在繁忙的展览期间可以得到适当的休息。此外，他们也希望会展提供更好的信息指引和导览，以帮助他们更好地了解展览的内容和安排。
          总的来说，我们的调查结果显示参与者对会展持有积极态度，并且有很高的期望。这些反馈将帮助我们进一步改善会展的组织和服务，以提供更好的参展体验和商务机会。</label>
      </div>
      <div class="item">
        <div class="items"
            id="main7"
            v-if="true"></div>
        <div class="items"
            id="main8"
            v-if="true"></div>
      </div>
    </div>
  </ShowControl>
</template>

<script>
import { mapState } from "vuex";
import ShowControl from "../../UserControl/ShowControl.vue"
export default {
  components: {
    ShowControl
  },
  data () {
    return {
      option: {

      },
      option2: {

      },
      option3: {
      },
      option4: {

      },
      title: '反馈数据管理'
    };
  },
  computed: {
    ...mapState({
      Round: (state) => state.user.round,
      ChatShow:(state) => state.user.chatShows,
    }),
  },
  created () {
  },
  mounted () {
    this.GetSurvey()
    this.$refs.showControl.receiveValue(true);
  },
  methods: {
    revertClick(){
      this.$router.push("/DataAnalysis")
    },
    GetSurvey () {
      this.$http.get(`Survey/GetSurvey?round=${this.Round}`).then((res) => {
        if (res.success) {
          this.option = {
            title: {
              text: "参会人员",
              left: "center",
            },
            tooltip: {
              trigger: "item",
            },
            series: [
              {
                type: "pie",
                radius: "50%",
                data: res.dynamicObj.dudienceSatisfied,
                emphasis: {
                  itemStyle: {
                    shadowOffsetX: 0,
                    shadowColor: "rgba(0, 0, 0, 0.5)",
                  },
                },
              },
            ],
            grid: {
              left: "3%",
              right: "4%",
              bottom: "3%",
              containLabel: true,
            },
          }
          this.option2 = {
            title: {
              text: '参展观众再次参加',
              left: 'center'
            },
            tooltip: {
              trigger: "item",
            },
            series: [
              {
                type: "pie",
                radius: "50%",
                data: res.dynamicObj.dudienceIsParticipate,
                emphasis: {
                  itemStyle: {
                    shadowOffsetX: 0,
                    shadowColor: 'rgba(0, 0, 0, 0.5)'
                  }
                }
              }
            ]
          }
          this.option3 = {
            title: {
              text: '参展企业',
              left: 'center'
            },
            tooltip: {
              trigger: "item",
            },
            series: [
              {
                type: "pie",
                radius: "50%",
                data: res.dynamicObj.exhibitorSatisfied,
                emphasis: {
                  itemStyle: {
                    shadowOffsetX: 0,
                    shadowColor: "rgba(0, 0, 0, 0.5)",
                  },
                },
              },
            ],
          }
          this.option4 = {
            title: {
              text: '展商最次参加',
              left: 'center'
            },
            tooltip: {
              trigger: "item",
            },
            series: [
              {
                type: "pie",
                radius: "50%",
                data: res.dynamicObj.exhibitorIsParticipate,
                emphasis: {
                  itemStyle: {
                    shadowOffsetX: 0,
                    shadowColor: "rgba(0, 0, 0, 0.5)",
                  },
                },
              },
            ],
          }
          this.infos();
          this.$store.commit("chatShow",{ isOperate : !this.ChatShow, chatValue: this.Global.OperateType.查看反馈数据管理 });  
        } else {
          return this.$message.error(res.message)
        }
      })
    },
    infos () {
      //初始化时需要加上，确保操作的是最新的DOM
      this.$nextTick(_ => {
        console.log(_)
        var chartDom = document.getElementById("main5");
        var myChart1 = this.echarts.init(chartDom);
        myChart1.clear();
        myChart1.setOption(this.option);
        var myChart2 = this.echarts.init(document.getElementById("main6"));
        myChart2.clear();
        myChart2.setOption(this.option2);
        var chartDom3 = this.echarts.init(document.getElementById('main7'));
        var chartDom4 = this.echarts.init(document.getElementById('main8'));
        chartDom3.clear();
        chartDom3.setOption(this.option3);
        chartDom4.clear();
        chartDom4.setOption(this.option4);
        window.onresize = function () {
          chartDom4.resize();
          myChart2.resize();
          chartDom3.resize();
          myChart1.resize();
        };
      })
    }
  },
};
</script>

<style scoped>
* {
  padding: 0;
  margin: 0;
}
.containers {
  width: 100%;
  height: 100%;
  margin: 10px auto;
  display: flex;
  display: -webkit-flex; /* Safari */
}
.item {
  flex: 1;
  width: 33%;
  height: 100%;
  text-align: center;
  color: black;
  font-size: medium;
}
.items {
  width: 100%;
  height: 45%;
  display: flex;
}
</style>